import { IError, ILoading } from '@types';
import { IAppState } from '@store/reducers';

export const getDefaultCountry = (state: IAppState): string => state.status.defaultCountry;
export const getLoading = (state: IAppState): ILoading => state.status.loading;
export const isFormSubmitted = (state: IAppState): boolean => state.status.formSubmitted;
export const getError = (state: IAppState): IError | null => state.status.error;
export const getScrollToError = (state: IAppState): boolean => state.status.scrollToError;

export const getIsPostingAnOrder = (state: IAppState): boolean => !!state.status?.loading?.postingOrder;
